var ScrollHelper = /*@__PURE__*/ (function () {
    function ScrollHelper() {
        this.classToScrollTo = null;
    }
    ScrollHelper.getInstance = function () {
        if (!ScrollHelper.instance) {
            ScrollHelper.instance = new ScrollHelper();
        }
        return ScrollHelper.instance;
    };
    ScrollHelper.prototype.scrollToFirst = function (className) {
        this.classToScrollTo = className;
    };
    ScrollHelper.prototype.getOffset = function (elm) {
        var y = elm.offsetTop;
        var node = elm;
        while (node.offsetParent && node.offsetParent != document.body) {
            node = node.offsetParent;
            y += node.offsetTop;
        }
        y = y - document.getElementsByClassName('main-nav')[0].offsetHeight;
        return y;
    };
    ScrollHelper.prototype.doScroll = function () {
        if (!this.classToScrollTo) {
            return;
        }
        var navBarHeight = document.getElementsByClassName('main-nav')[0].getBoundingClientRect().height;
        try {
            var elements = document.getElementsByClassName(this.classToScrollTo);
            if (elements.length == 0) {
                return;
            }
            window.scroll({
                top: this.getOffset(elements[0]),
                behavior: 'smooth'
            });
            elements[0].scroll({ behavior: 'smooth' });
        }
        finally {
            this.classToScrollTo = null;
        }
    };
    return ScrollHelper;
}());
export default ScrollHelper;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/utils/scroll-helper.ts
// module id = null
// module chunks = 